import styled, { css } from "styled-components";
import { Icon } from "../icons";

const StyledItem = css<{ $canSelectMarket: boolean }>`
  cursor: ${({ $canSelectMarket }) =>
    $canSelectMarket ? "pointer" : "default"};
  display: flex;
  align-items: center;
  border: none;
  background: transparent;
  gap: ${(props) => props.theme.SPACING.MD};
`;

export const SelectedItemWrapper = styled.button<{ $canSelectMarket: boolean }>`
  width: 200px;
  ${StyledItem};
`;

export const StyledArrowDown = styled(Icon.Expand)``;

export const StyledWrapper = styled.div`
  position: relative;
  width: min-content;
  min-width: 200px;
  display: flex;
`;

export const StyledDropdownItem = styled.div<{
  $selected?: boolean;
  $canSelectMarket: boolean;
}>`
  ${StyledItem};
  padding: 8px 16px;
  & span {
    font-weight: ${({ $selected, theme }) =>
      $selected ? theme.FONT.WEIGHT.BOLD : theme.FONT.WEIGHT.REGULAR};
  }

  &:hover {
    background-color: ${({ theme }) => theme.COLORS.BLACK_GREY_OPACITY};
  }
`;

export const StyledDropdownWrapper = styled.div`
  display: block;
  box-shadow: 0px 2px 8px rgba(29, 27, 27, 0.2);
  background-color: ${({ theme }) => theme.COLORS.WHITE};
  min-width: 168px;

  & ${StyledDropdownItem}:not(:first-of-type) {
    padding-top: 8px;
  }
`;

export const StyledDropdownOuter = styled.div`
  position: absolute;
  // I don't really like it, but its best I can come up with quickly
  z-index: 1000;
  top: 37px;
`;
